import React from 'react';
import { __, Message } from 'first-intl';
import { TRACK_ID } from '@hugendubel/tracking_client';
import { A, ATarget } from '@hugendubel/react-basic';
import { COMPANY, PRIVACY, TERMS_AND_CONDITIONS, IMPRINT, CONTACT } from '../../external-urls';

type FooterLinkProps = { href: string; label: Message; target?: ATarget };

export const FooterLink: React.FC<FooterLinkProps> = ({ href, label, target }) => (
    <li>
        <A trackId={TRACK_ID('2019-07-31 06:15:48')} {...{ href, target }}>
            {__(label)}
        </A>
    </li>
);

export const Footer: React.FC = () => (
    <footer>
        <div className="container-fluid">
            <ul className="meta-nav">
                <FooterLink href={COMPANY} target="_self" label="footer.company" />
                <FooterLink href={PRIVACY} target="_self" label="footer.dataSecurity" />
                <FooterLink href={TERMS_AND_CONDITIONS} target="_self" label="footer.termsAndConditions" />
                <FooterLink href={IMPRINT} target="_self" label="footer.imprint" />
                <FooterLink href={CONTACT} target="_self" label="footer.contact" />
            </ul>
        </div>
    </footer>
);
